import gql from 'graphql-tag';

export default gql`
  mutation(
    $name: String!
    $institutionId: ID!
    $budget: Int
    $goal: ProjectGoal!
    $keywords: [String!]
    $invitedBookshop: ID!
  ) {
    addProject(
      input: {
        libraryId: $institutionId
        name: $name
        requirements: { budget: $budget, keywords: $keywords }
        goal: $goal
        invitedBookshop: $invitedBookshop
      }
    ) {
      id
    }
  }
`;
